"use client"

import { useTransition } from "react"
import { useRouter } from "next/navigation"
import { disableDraftMode } from "@/app/actions"
import { useIsClient } from "@/ui/hooks/useIsClient"

export function DisableDraftMode() {
  const router = useRouter()
  const [pending, startTransition] = useTransition()
  const isClient = useIsClient()

  const disable = () =>
    // @ts-ignore
    startTransition(async () => {
      await disableDraftMode()
      router.refresh()
    })

  if (!isClient) {
    return <></>
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {pending ? (
        <div className="bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg">
          Disabling draft mode...
        </div>
      ) : (
        <button
          type="button"
          onClick={disable}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg shadow-lg transition-colors flex items-center gap-2"
        >
          Exit draft mode
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </div>
  )
}
